import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllReses = createAsyncThunk(
  "Reses/fetchAllReses",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.RESES, params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addReses = createAsyncThunk(
  "Reses/addReses",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.RESES, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateReses = createAsyncThunk(
  "Reses/updateReses",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.RESES}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const fetchOneReses = createAsyncThunk(
  "Reses/fetchOneReses",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.RESES}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteReses = createAsyncThunk(
  "Reses/deleteReses",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.RESES}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const ResesSlice = createSlice({
  name: "Reses",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllReses.pending, startLoadingQuery)
      .addCase(fetchAllReses.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllReses.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneReses.pending, startLoadingQuery)
      .addCase(fetchOneReses.rejected, stopLoadingQuery)
      .addCase(fetchOneReses.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateReses.pending, startLoadingQuery)
      .addCase(updateReses.rejected, stopLoadingQuery)
      .addCase(updateReses.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteReses.pending, startLoadingMutation)
      .addCase(deleteReses.fulfilled, stopLoadingMutation)
      .addCase(deleteReses.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = ResesSlice.actions;

export default ResesSlice.reducer;
